<template>
  <div>
    <OrganizationFields :v="v" />

    <ExtractionRodAssignee
      :v="v.assignee"
      label="Сведения о представителе юридического лица"
    />
  </div>
</template>

<script>
import deepmerge from 'deepmerge';

import { getValidationErrorText } from '@/utils/validate';
import ExtractionRodAssignee, {
  assigneeModel,
  assigneeValidate,
} from './ExtractionRodAssignee';
import OrganizationFields, {
  organizationFieldsModel,
  organizationFieldsValidation,
} from '@/components/services/ExtractionRod/Applicant/OrganizationFields';

export const organizationModel = deepmerge.all([
  organizationFieldsModel,
  { assignee: assigneeModel },
]);

export const getOrganizationValidation = (organization) => ({
  ...organizationFieldsValidation,
  assignee: assigneeValidate(organization.assignee),
});

export default {
  name: 'Organization',
  props: {
    v: {
      type: Object,
      required: true,
    },
  },
  components: {
    OrganizationFields,
    ExtractionRodAssignee,
  },
  data: () => ({
    getValidationErrorText,
  }),
};
</script>
